/**
 * 同じキー（例: ユーザーID）の処理が実行中なら、その Promise を共有する（指示書 A-15）。
 * 結果は保存しない。終わった後の呼び出しは、改めて実行する（無期限のキャッシュにしない）。
 * 別のキーで呼ばれたら、新しく実行する（前のユーザーの実行中の処理を共有しない。A-16）。
 */
export function createKeyedSingleFlight() {
  /** @type {{ key: any, promise: Promise<any> } | null} */
  let current = null
  return {
    run(key, task) {
      if (current && current.key === key) return current.promise
      const entry = { key, promise: null }
      entry.promise = Promise.resolve()
        .then(task)
        .finally(() => {
          if (current === entry) current = null
        })
      current = entry
      return entry.promise
    },
    /** 実行中の共有をやめる（ログアウト時など）。実行中の処理そのものは止まらない */
    clear() {
      current = null
    }
  }
}
